import {ISIMG} from '../constact'

const isImgInit = false;
export default function isImg(preState = isImgInit, action) {
    const {type, data} = action;
    switch (type) {
        case ISIMG:
            return data;
        default:
            return preState;
    }
}